import {createSelector} from "reselect";
import {languagesSelectorKeys} from "./selectorKeys";

const languages_S = state => state.language;

const creatorFn = selectorKey => {
    return createSelector(languages_S, data => data[selectorKey])
};

export const languagesSelectors = state => {
    const sData = {};

    languagesSelectorKeys.forEach(key => {
        sData[key] = creatorFn(key)(state)
    });

    return sData;
};